const payingOrgsPickerStrings = {
  splitBySalaryFraction: "Deles etter honorarbrøk",
  salaryFractionExplanation: "{org} betaler {parts}/{total} del av beløpet | {org} betaler {parts}/{total} deler av beløpet"
};

export default payingOrgsPickerStrings;